export default function (app) {
  app.controller('klAccountAddressCtrl', [
    '$q',
    'klAccountService',
    'klNotificationService',
    '$http',
    function ($q, AccountService, NotificationService, $http) {
      const ctrl = this;
      ctrl.isLoading = true;
      ctrl.formInvalid = false;

      const vatCountries = [
        'AT',
        'BE',
        'BG',
        'CY',
        'CZ',
        'DE',
        'DK',
        'EE',
        'EL',
        'ES',
        'FI',
        'FR',
        'HR',
        'HU',
        'IE',
        'IT',
        'LT',
        'LU',
        'LV',
        'MT',
        'NL',
        'PL',
        'PT',
        'RO',
        'SE',
        'SI',
        'SK',
        'UK',
      ];

      ctrl.isVatCountry = function (country) {
        return vatCountries.indexOf(country) > -1;
      };

      const isAvalaraTerritory = function (countryCode) {
        return Boolean(
          ['US', 'CA', 'AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'UM', 'VI'].indexOf(countryCode) >
            -1,
        );
      };

      const setData = (account) => {
        if (!account) {
          return;
        }
        ctrl.account = JSON.parse(JSON.stringify(account));
        ctrl.isReseller = AccountService.isReseller;
        ctrl.getFirstName = AccountService.getFirstName;
        ctrl.isLoading = false;
      };

      AccountService.fetchAccount().then(setData);

      ctrl.getFirstName = AccountService.getFirstName;

      ctrl.save = function (isValid) {
        if (ctrl.isProcessing) {
          return;
        }
        if (!isValid) {
          ctrl.formInvalid = true;
          NotificationService.putError('auth', 'error_required_fields');
          return;
        }
        ctrl.formProcessing = true;
        if (!!ctrl.account.vatId && ctrl.isVatCountry(ctrl.account.billToContact.country)) {
          return isVatValid()
            .then(() => AccountService.saveAccount(ctrl.account))
            .then(() => NotificationService.putSuccess('success_address'))
            .catch((e) => NotificationService.putError('', e))
            .finally(() => {
              ctrl.formProcessing = false;
            });
        } else if (isAvalaraTerritory(ctrl.account.billToContact.country)) {
          ctrl.account.billToContact.zipCode = ctrl.account.billToContact.zipCode.replace(
            /\D/g,
            '',
          );
          return AccountService.verifyAddress(ctrl.account).then((response) => {
            if (!response || !response.data || response.data.isAddressVerified != true) {
              ctrl.formInvalid = true;
              NotificationService.putError(
                'auth',
                "We couldn't verifiy this Address. Please check for Typos!",
              );
            } else {
              return AccountService.saveAccount(ctrl.account).then(() => {
                ctrl.formInvalid = false;
                ctrl.formProcessing = false;
                NotificationService.putSuccess('success_address');
              });
            }
          });
        } else {
          return AccountService.saveAccount(ctrl.account).then(() => {
            ctrl.formInvalid = false;
            ctrl.formProcessing = false;
            NotificationService.putSuccess('success_address');
          });
        }
      };
      function isVatValid() {
        return $http
          .get('/api/vat/' + ctrl.account.vatId)
          .then((response) => {
            if (response.data) {
              return response.data;
            }
            return response;
          })
          .then((result) => {
            if (result) {
              return result;
            }
            throw new Error('VAT ID verification service is unavailable. Please try again later.');
          })
          .then((result) => {
            if (result.valid == true) {
              return;
            }

            ctrl.formInvalid = true;
            const re = new RegExp(
              '^(ATU[0-9]{8}|BE[01][0-9]{9}|BG[0-9]{9,10}|HR[0-9]{11}|CY[A-Z0-9]{9}|CZ[0-9]{8,10}|DK[0-9]{8}|EE[0-9]{9}|FI[0-9]{8}|FR[0-9A-Z]{2}[0-9]{9}|DE[0-9]{9}|EL[0-9]{9}|HU[0-9]{8}|IE([0-9]{7}[A-Z]{1,2}|[0-9][A-Z][0-9]{5}[A-Z])|IT[0-9]{11}|LV[0-9]{11}|LT([0-9]{9}|[0-9]{12})|LU[0-9]{8}|MT[0-9]{8}|NL[0-9]{9}B[0-9]{2}|PL[0-9]{10}|PT[0-9]{9}|RO[0-9]{2,10}|SK[0-9]{10}|SI[0-9]{8}|ES[A-Z]([0-9]{8}|[0-9]{7}[A-Z])|SE[0-9]{12}|GB([0-9]{9}|[0-9]{12}|GD[0-4][0-9]{2}|HA[5-9][0-9]{2}))$',
            );
            if (!re.test(ctrl.account.vatId)) {
              throw new Error('Please Correct your VAT ID (ex.: DE999999999)');
            }
            throw new Error('Typo? Entered VAT ID is invalid');
          });
      }
    },
  ]);
}
